import { notification } from 'antd';
import { cache } from '@/container/apollo-client/cache';
import { useImportBulkContactProgressSubscription } from '@/types/generated/graphql';
import { useImportStore } from '@shared/store/import-store';
import { useTranslation } from 'react-i18next';
import { capitalize } from '@shared/utils/capitalize';

export const useContactImportSubscription = () => {
  const { referenceId, setReferenceId, setProgres } = useImportStore();
  const { t } = useTranslation();
  useImportBulkContactProgressSubscription({
    variables: { eventReferenceId: referenceId },
    skip: !referenceId,
    onData: (res) => {
      const data = res?.data?.data;
      const status = data?.importBulkContactProgress;
      setProgres(status?.progress || 0);
      if (status?.status === 'completed') {
        setReferenceId('');
        setProgres(null);
        notification.success({
          message: capitalize(t('import_success')),
          description: t('contact_imported_successfully'),
        });
        cache.modify({
          fields: {
            contactsV2: () => {},
            getContactsCount: () => {},
          },
        });
      }
    },
    onError: (err) => {
      setReferenceId('');
      setProgres(null);
      notification.error({
        message: capitalize(t('import_error')),
        description: err?.message || t('an_error_occurred_during_import'),
      });
    },
  });
};
